export const ENCRYPT_REQUEST = "ENCRYPT_REQUEST";
export const ENCRYPT_SUCCESS = "ENCRYPT_SUCCESS";
export const ENCRYPT_FAILED = "ENCRYPT_FAILED";